import { render, staticRenderFns } from "./AddCountry.vue?vue&type=template&id=62d65354&scoped=true&"
import script from "./AddCountry.vue?vue&type=script&lang=js&"
export * from "./AddCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d65354",
  null
  
)

export default component.exports